module.exports = __webpack_public_path__ + "img/logo.7277adf6.png";